import { render } from "./myActivity.vue?vue&type=template&id=71f85983"
import script from "./myActivity.vue?vue&type=script&lang=js"
export * from "./myActivity.vue?vue&type=script&lang=js"

import "./myActivity.vue?vue&type=style&index=0&id=71f85983&lang=scss"

import exportComponent from "/Users/wanggaochao/项目/善城 (2)/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__